$mol_text_demo $mol_example_large
	title \Markdown visualization example
	sub /
		<= Book $mol_book2
			Placeholder null
			pages <= pages /
				<= View_page $mol_page
					title \Output
					tools /
						<= Search $mol_search_jumper
							query? <=> search? \
							Root <= View
						<= Edit $mol_link
							arg * edit \
							sub /
								<= Edit_icon $mol_icon_pencil
					body /
						<= View $mol_text
							text <= text
							highlight <= search
				<= Code_page $mol_page
					title \Input
					tools /
						<= Close $mol_link
							arg * edit null
							sub /
								<= Close_icon $mol_icon_close
					body /
						<= Code $mol_textarea
							value? <=> text? \
								\# Header level 1
								\## Header level 2
								\### Header level 3
								\#### Header level 4
								\##### Header level 5
								\###### Header level 6
								\
								\# List
								\
								\- first item
								\  1. first of first item
								\  2. second of first item
								\  > quote as item
								\  > > quote in quote
								\  > + list inside quote
								\- second item
								\
								\# Inline Formatting
								\
								\- Some **strong text**
								\- Some *emphasis text*
								\- Some ~~deleted text~~
								\- Some `short_code("foo")` & ```long_code(`${bar}`)```
								\- Some "quoted text"
								\
								\# Hyper Link
								\
								\* Some [link *with* title](http://example.org).
								\* Auto http link: http://mol.hyoo.ru, (http://mol.hyoo.ru), http://mol.hyoo.ru.
								\* Some [*unsafe* link](somescript:document.cookie).
								\
								\# Embedding
								\
								\## Image
								\![](https://mol.hyoo.ru/mol/logo/logo.svg)
								\
								\## Video
								\![](https://www.youtube.com/embed/XNt7DEkisKg)
								\
								\## Site
								\![](https://life.hyoo.ru)
								\
								\## Inline
								\
								\- Badge: [![Deploy](https://github.com/hyoo-ru/mam_mol/actions/workflows/deploy.yml/badge.svg)](https://github.com/hyoo-ru/mam_mol/actions/workflows/deploy.yml)
								\- Broken images: ![*Alternative* text](https://example.org/404.png) ![](https://example.org/404.svg)
								\- Unsafe images: ![*Alternative* text](somescript:document.cookie) ![](somescript:document.cookie)
								\
								\# Preformatted Code
								\
								\```js
								\class SomeCode {
								\	with_prolog: true
								\}
								\```
								\
								\	class SomeCode {
								\		with_indents: true
								\	}
								\
								\# Table
								\
								\|           | ~~Column~~ 1 | ~~Column~~ 2 | ~~Column~~ 3
								\|-----------|--------------|--------------|-------------
								\| ~~Row~~ 1 | ~~Cell~~ 1x1 | ~~Cell~~ 2x1 | ~~Cell~~ 3x1
								\| ~~Row~~ 2 | ~~Cell~~ 1x2 | ~~Cell~~ 2x2 | ~~Cell~~ 3x2
								\| ~~Row~~ 3 | ~~Cell~~ 1x3 | ~~Cell~~ 2x3 | ~~Cell~~ 3x3
								\| ~~Row~~ 4 | ~~Cell~~ 1x4 | ~~Cell~~ 2x4 | ~~Cell~~ 3x4
								\| ~~Row~~ 5 | ~~Cell~~ 1x5 | ~~Cell~~ 2x5 | ~~Cell~~ 3x5
								\| ~~Row~~ 6 | ~~Cell~~ 1x6 | ~~Cell~~ 2x6 | ~~Cell~~ 3x6
								\| ~~Row~~ 7 | ~~Cell~~ 1x7 | ~~Cell~~ 2x7 | ~~Cell~~ 3x7
								\| ~~Row~~ 8 | ~~Cell~~ 1x8 | ~~Cell~~ 2x8 | ~~Cell~~ 3x8
								\| ~~Row~~ 9 | ~~Cell~~ 1x9 | ~~Cell~~ 2x9 | ~~Cell~~ 3x9
								\
	tags /
		\markdown
		\marked
	aspects /
		\Widget/Text
		\Type/String
